import createAssoc from '@/services/functions/create-assoc';

export default {
  sellerStatuses: (state) => createAssoc(state.sellerStatuses, 'value'),
  sellerStatusesForSelect: (state) => state.sellerStatuses,
  availableSellers: (state) => state.availableSellers,
  contactSteps: (state) => state.contactSteps,
};
